import React, { useState } from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";

const TwichToolPage = () => {
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);

  const twichToolUrl = "https://www.youtube.com/watch?v=5GcrnPh8yRE";
  const closeModal = () => {
    setSelectedVideo(null);
  };

  return (
    <div className="flex flex-col min-h-screen bg-black">
      <Header />
      <main className="flex-grow">
        <div className="relative">
          <img
            alt="twich-tool-bg"
            src="assets/img/twich-tool/bg.png"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="relative z-10 flex flex-col items-center px-4 pt-10 pb-20 sm:pt-16">
            {/* Small screen header */}
            <div className="lg:hidden flex flex-col items-center text-center">
              <img
                alt="twich-tool-thunder-logo"
                src="assets/img/thunder-logo.png"
                className="w-[70%] md:w-[50%]"
              />
              <img
                alt="twich-tool-title"
                src="assets/img/twich-tool/title.png"
                className="mt-4 w-[95%]"
              />
              <img
                alt="twich-tool-title-line"
                src="assets/img/landing/title-line.png"
                className="mt-2 w-[90%] md:w-[60%]"
              />
            </div>

            {/* Large screen header */}
            <div className="hidden lg:flex flex-col items-center text-center">
              <img
                alt="twich-tool-thunder-logo"
                src="assets/img/thunder-logo.png"
                className="w-[50%]"
              />
              <img
                alt="twich-tool-title"
                src="assets/img/twich-tool/title.png"
                className="-mt-10 w-[72%]"
              />
              <img
                alt="twich-tool-title-line"
                src="assets/img/landing/title-line.png"
                className="-mt-2 w-[50%] h-[12px]"
              />
            </div>

            {/* Download Buttons */}
            <div className="w-full max-w-4xl mt-8">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <a href="IPlayMore-0.1.0.AppImage" download className="gothic-glass-effect relative overflow-hidden">
                  <div className="flex flex-col items-center p-4">
                    <img src="https://www.freepnglogos.com/uploads/linux-png/penguin-linux-cartoon-png-icons-and-png-23.png" alt="Linux Logo" className="w-16 h-16" />
                    <span>Linux</span>
                  </div>
                  <div className="absolute top-2 right-[-30px] bg-green-500 text-white text-xs font-bold px-10 py-1 transform rotate-45">Download</div>
                </a>
                <a href="IPlayMore-0.1.0.exe" download className="gothic-glass-effect relative overflow-hidden">
                  <div className="flex flex-col items-center p-4">
                    <img src="https://www.freepnglogos.com/uploads/windows-logo-png/windows-logo-logok-0.png" alt="Windows Logo" className="w-16 h-16" />
                    <span>Windows</span>
                  </div>
                  <div className="absolute top-2 right-[-30px] bg-green-500 text-white text-xs font-bold px-10 py-1 transform rotate-45">Download</div>
                </a>
                <a href="#" className="gothic-glass-effect relative overflow-hidden cursor-not-allowed">
                  <div className="flex flex-col items-center p-4">
                    <img src="https://www.freepnglogos.com/uploads/apple-logo-png/apple-logo-png-dallas-shootings-don-add-are-speech-zones-used-4.png" alt="Apple Logo" className="w-16 h-16" />
                    <span>Mac</span>
                  </div>
                  <div className="absolute top-2 right-[-30px] bg-red-500 text-white text-xs font-bold px-10 py-1 transform rotate-45">Coming Soon</div>
                </a>
              </div>
            </div>

            {/* Specs Table */}
            <div className="w-full max-w-4xl mt-10 text-white">
              <h2 className="text-2xl font-bold text-center mb-4">Download Specifications</h2>
              <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse">
                  <thead>
                    <tr>
                      <th className="border-b-2 border-gray-500 px-4 py-2">OS</th>
                      <th className="border-b-2 border-gray-500 px-4 py-2">File Size</th>
                      <th className="border-b-2 border-gray-500 px-4 py-2">Compatibility</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border-b border-gray-500 px-4 py-2">Linux (AppImage)</td>
                      <td className="border-b border-gray-500 px-4 py-2">210 MB</td>
                      <td className="border-b border-gray-500 px-4 py-2">Most modern Linux distributions</td>
                    </tr>
                    <tr>
                      <td className="border-b border-gray-500 px-4 py-2">Windows</td>
                      <td className="border-b border-gray-500 px-4 py-2">259 MB</td>
                      <td className="border-b border-gray-500 px-4 py-2">Windows 10 and newer</td>
                    </tr>
                    <tr>
                      <td className="px-4 py-2">Mac</td>
                      <td className="px-4 py-2">289 MB</td>
                      <td className="px-4 py-2">macOS 11 and newer</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Large Screen Video */}
            <div className="hidden lg:block w-full max-w-2xl mt-10">
              <div className="aspect-video">
                <iframe
                  width="100%"
                  height="100%"
                  src={`https://www.youtube.com/embed/${twichToolUrl.split("v=")[1]}`}
                  title="Selected Video"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            {/* Small Screen Content Section */}
            <div className="lg:hidden w-full mt-14">
              <div
                style={{
                  backgroundImage: "url(assets/img/landing/section-line.png)",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                className="w-full h-[26px]"
              />
              <div className="relative bg-[#0e151d] py-8 flex flex-col items-center text-center">
                <img
                  alt="twich-tool-bg-2"
                  src="assets/img/landing/landing-bg-2.png"
                  className="absolute inset-0 w-full h-full object-cover opacity-60"
                />
                <div className="relative w-11/12 md:w-3/4 max-w-xl aspect-video">
                  <iframe
                    width="100%"
                    height="100%"
                    src={`https://www.youtube.com/embed/${twichToolUrl.split("v=")[1]}`}
                    title="Selected Video"
                    allowFullScreen
                  ></iframe>
                </div>
                <p className="text-sm text-left mt-4 w-11/12 md:w-3/4 max-w-xl relative z-10">
                  When a viewer is randomly selected, they will have the
                  opportunity, by writing in chat during the event, to obtain a
                  code to redeem a random gear that will be stored in their
                  profile, ready to be used right away in game and viewable in the
                  online marketplace.
                  <br />
                  <br />
                  Subscribe to get the latest updates!
                </p>
                <img
                  alt="twich-tool-character"
                  src="assets/img/twich-tool/character.png"
                  className="relative mt-4 w-[300px] h-auto"
                />
              </div>
            </div>
          </div>
        </div>
        {selectedVideo && (
          <div
            className="z-[5000] fixed inset-0 flex justify-center items-center bg-black bg-opacity-75"
            onClick={closeModal}
          >
            <div className="w-full max-w-3xl aspect-video mx-4">
              <iframe
                className="w-full h-full"
                src={`https://www.youtube.com/embed/${selectedVideo.split("v=")[1]}`}
                title="Selected Video"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default TwichToolPage;
